import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import logo from "../assets/logo.png";
import { Menu, X, Sprout, History, FlaskConical, Mail } from "lucide-react";

const Navbar: React.FC = () => {
  const { t } = useLanguage();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const navigationLinks = [
    { to: "/benefits", label: t('nav.benefits') },
    { to: "/about", label: t('nav.ourStory') },
    { to: "/gallery", label: t('nav.gallery') },
    { to: "/specifications", label: t('nav.specifications') },
    { to: "/contact", label: t('nav.contact') }
  ];

  return (
    <nav className="sticky top-0 z-50 w-full h-20 flex items-center bg-background-light/80 dark:bg-background-dark/80 backdrop-blur-md border-b border-primary/10 dark:text-white">

      {/* Container */}
      <div className="max-w-7xl mx-auto w-full px-6 flex items-center justify-between h-full">

        {/* Logo */}
        <Link
          to="/"
          className="flex items-center flex-shrink-0"
          onClick={closeMobileMenu}
        >
          <img
            src={logo}
            alt="SAMSON ORGO Plants Logo"
            className="w-[11rem] object-contain"
          />
        </Link>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-8">
          {navigationLinks.map((link, index) => (
            <Link
              key={index}
              to={link.to}
              className="font-semibold text-sm hover:text-primary transition-colors relative group"
            >
              {link.label}

              <span className="absolute -bottom-1 left-0 w-0 h-[2px] bg-primary group-hover:w-full transition-all duration-300"></span>
            </Link>
          ))}
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden p-2 rounded-lg hover:bg-primary/10 transition-colors"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label={isMobileMenuOpen ? "Close menu" : "Open menu"}
          aria-expanded={isMobileMenuOpen}
        >
          {isMobileMenuOpen ? (
            <X className="w-6 h-6 text-emerald-900 dark:text-white" />
          ) : (
            <Menu className="w-6 h-6 text-emerald-900 dark:text-white" />
          )}
        </button>

      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="absolute top-20 left-0 w-full md:hidden bg-background-light dark:bg-background-dark border-t border-primary/10 animate-slideDown">

          <div className="max-w-7xl mx-auto px-6 py-4">

            <div className="flex flex-col gap-1">

              {navigationLinks.map((link, index) => (
                <Link
                  key={index}
                  to={link.to}
                  onClick={closeMobileMenu}
                  className="flex items-center gap-3 py-3 px-4 rounded-lg font-semibold text-emerald-900 dark:text-white hover:text-primary hover:bg-primary/5 transition-all duration-200"
                >

                  {index === 0 ? (
                    <Sprout className="w-5 h-5 text-primary" />
                  ) : index === 1 ? (
                    <History className="w-5 h-5 text-primary" />
                  ) : index === 2 ? (
                    <FlaskConical className="w-5 h-5 text-primary" />
                  ) : (
                    <Mail className="w-5 h-5 text-primary" />
                  )}

                  {link.label}

                </Link>
              ))}

            </div>

            {/* Language Section */}
            <div className="mt-6 pt-6 border-t border-emerald-200 dark:border-emerald-800/30 flex justify-center">

              <div className="flex items-center gap-4">

                <span className="text-sm text-emerald-800/60 dark:text-emerald-100/40">
                  {t('language.current')}
                </span>

                <span className="font-semibold text-primary">
                  {t('language.code') === 'mr' ? 'मराठी' : 'English'}
                </span>

              </div>

            </div>

          </div>

        </div>
      )}
    </nav>
  );
};

export default Navbar;